import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { log } from "../../utils/logger";
import "./Anketa.css";

export const Login = () => {
    const navigate = useNavigate();
    const { login } = useAuth();

    const [email, setEmail] = useState("");
    const [pass, setPass] = useState("");
    const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});
    const [serverError, setServerError] = useState("");
    const [endpointAddress, setEndpointAddress] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        fetch("/config.json")
            .then((res) => res.json())
            .then((config) => {
                if (config["endpoint-address"]) setEndpointAddress(config["endpoint-address"]);
                log("Login", "Загружен config", { hasEndpoint: !!config["endpoint-address"] });
            })
            .catch((err) => log("Login", "Ошибка загрузки config", err));
    }, []);

    const validate = (): Record<string, string> => {
        const err: Record<string, string> = {};
        if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) err.email = "Введите корректный email";
        if (!pass.trim()) err.pass = "Не указан пароль";
        return err;
    };

    const handleSubmit = async () => {
        setServerError("");
        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            log("Login", "Валидация не пройдена", errors);
            return;
        }
        if (!endpointAddress) {
            log("Login", "Нет endpoint, отправка отменена");
            setServerError("Сервис временно недоступен.");
            return;
        }

        log("Login", "Отправка запроса входа", { email: email.trim() });
        setSubmitting(true);
        try {
            const res = await fetch(`${endpointAddress}/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: email.trim(), password: pass }),
            });
            const data = await res.json().catch(() => ({}));
            log("Login", "Ответ сервера", { status: res.status, dataStatus: data.status });

            if (data.status === "1" && data.id != null && data.token != null) {
                localStorage.setItem("id", String(data.id));
                localStorage.setItem("token", String(data.token));
                login();
                log("Login", "Вход выполнен успешно, переход на главную");
                navigate("/");
                return;
            }
            if (data.status === "2") {
                log("Login", "Неверная почта или пароль");
                setServerError("Неверная почта или пароль");
                return;
            }
            log("Login", "Неизвестный ответ сервера", data);
            setServerError("Ошибка входа. Попробуйте позже.");
        } catch (err) {
            log("Login", "Ошибка соединения", err);
            setServerError("Ошибка соединения. Попробуйте позже.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="anketa-container">
            <div className="register-card">
                <div className="question-section">
                    <h2 className="question-text">Вход в аккаунт</h2>
                </div>

                <div className="form-section">
                    <div className="form-group">
                        <label>Email</label>
                        <input
                            type="text"
                            value={email}
                            placeholder="example@example.com"
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        {fieldErrors.email && <div className="field-error">{fieldErrors.email}</div>}
                    </div>
                    <div className="form-group">
                        <label>Пароль</label>
                        <div className="password-input-wrapper">
                            <input
                                type={showPassword ? "text" : "password"}
                                value={pass}
                                onChange={(e) => setPass(e.target.value)}
                            />
                            <button
                                type="button"
                                className="password-toggle-btn"
                                onClick={() => setShowPassword(!showPassword)}
                                title={showPassword ? "Скрыть пароль" : "Показать пароль"}
                            >
                                {showPassword ? "👁️" : "👁️‍🗨️"}
                            </button>
                        </div>
                        {fieldErrors.pass && <div className="field-error">{fieldErrors.pass}</div>}
                        <div style={{ marginTop: "0.5rem", fontSize: "0.9rem" }}>
                            <button
                                type="button"
                                className="link-button"
                                onClick={() => navigate("/forgot-password")}
                                style={{ background: "none", border: "none", color: "var(--accent)", cursor: "pointer", padding: 0, textDecoration: "underline" }}
                            >
                                Забыли пароль?
                            </button>
                        </div>
                    </div>
                    {serverError && (
                        <div className="field-error" style={{ marginTop: "0.5rem", color: "var(--error)" }}>
                            {serverError}
                        </div>
                    )}
                </div>

                <div className="navigation-section">
                    <button className="nav-btn prev-btn" onClick={() => navigate("/")} type="button">
                        ← На главную
                    </button>
                    <button
                        className="nav-btn submit-btn"
                        onClick={handleSubmit}
                        type="button"
                        disabled={submitting}
                    >
                        {submitting ? "Вход..." : "Войти"}
                    </button>
                </div>
            </div>
        </div>
    );
};